/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScuolaAssegnataItem { 
    id?: string;
    nome?: string;
    istituto_nome?: string;
    plesso_attivo?: boolean;
}

